module.exports = __webpack_public_path__ + "img/money-matters-1173120-639x426.e4609049.png";